import React, { useState,useEffect, useContext } from "react"
import styled from "styled-components"
import Loader1 from "../../interceptors/loader-interceptor"
import { JourneyContext } from "../context/journeyContext"
import {
  findCurrentJourneyCode,
  getDateInFormat,
  isPostRFITransaction,
  mapReceiptEnquiryToPaymentStatus,
  buildPostRFISuccessTransaction,
} from "../services/helperFunctions"
import {
  paymentText,
  saveApplication,
  saveTransactionDetails,
  fetchAllJourneyData,
  checkPaymentStatusCPG,
  checkPaymentStatusEnquiry,
  saveBasbaTransactionLogs,
} from "../../services/apiservice"
import { ErrorContext } from "../context/errorContext";
import * as lookup from "../../../static/lookup.json"
import { errorToastr } from "../../services/error-handler"
import { ChequePaymentTypes, SIPaymentTypes } from "../../shared/constant"

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > input {
  }
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    min-height: 2rem;
  }
`

export default function UnsuccessfulTransaction(props) {
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const[errorState, setErrorState] = useContext(ErrorContext);
  const[checkstatus,setCheckstatus] =useState(false);
  const [allJourneyData, setAllJourneyData] = useState()

  const lastTransaction = allJourneyData?.transactionDetails?.transactions?.slice(-1)[0]
  const isPostRFIPayment =
    isPostRFITransaction(lastTransaction) ||
    isPostRFITransaction(journeyState.paymentDecryptData)

  const promoteToSuccessfulSection = (temp, transactionObj) => {
    const tempPageIndexToChange = temp.pages.findIndex(
      element => element.pageId === "makePayment"
    )
    const pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.map(element => {
      if (element.sectionId === "unsuccessful-transaction") {
        element.sectionId = "successful-transaction"
        element.name = "Successful Transaction"
      }
      return element
    })
    temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
    setJourneyState(prev => ({
      ...prev,
      journeySteps: temp,
      paymentDecryptData: transactionObj,
    }))
  }

  // old pay-later-logic
  /* const handlePayLater = () => {
    props.setCurrentPageIndex(prev => prev + 1)
    props.setCurrentSectionIndex(0) // this moves to first section of next page

    setJourneyState((prev) => {
      return ({
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
      })
    })

  } */
  useEffect(() => {
    if (!journeyState?.journeyId) return;
    let payload = {
      journeyId: journeyState.journeyId,
    }
    fetchAllJourneyData(payload)
      .then(res => {
        setAllJourneyData(res)
      })
      .catch(err => {
        console.log(err)
      })
  }, [journeyState?.journeyId])
  const handlePayLater = () => {

    let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: journeyState.premium ,
        lastPageCode: props.pageId,
        paymentStep:  'L',
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
      },
    }
    saveApplication(sendPayload).then(res => {
      let lastPage = props.currentPageIndex
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
      let injectSuccessUnsuccesPaymentSection = [
        {
          "sectionId": "unsuccessful-transaction",
          "isSubsection": false,
          "ParentSectionName": null,
          "name": "Unsuccessful Transaction",
          "class": null,
          "conditions": [],
          "component_groups": []
        },
        {
          "sectionId": "successful-transaction",
          "isSubsection": false,
          "ParentSectionName": null,
          "name": "Successful Transaction",
          "class": null,
          "conditions": [],
          "component_groups": []
        }
      ]
      temp.pages[tempPageIndexToChange].sections = [...temp.pages[tempPageIndexToChange].sections, ...injectSuccessUnsuccesPaymentSection];
      console.log(temp.pages[tempPageIndexToChange].sections, "injectSuccessUnsuccesPaymentSection")
      if (lastPage === 2 && temp.pages[2].pageId === "makePayment") {
      let element = temp.pages[3]
      temp.pages.splice(3, 1)
      temp.pages.splice(2, 0, element)
      console.log(temp, "pendingProceedAction")
    }
      // props.setCurrentPageIndex(prev => prev + 1)

    setJourneyState((prev) => {
      return ({
        ...prev,
        paymentStep: "L",
        journeySteps: temp,
      })
    })
    setErrorState({})
    props.setCurrentSectionIndex(0) // this moves to first section of next page
    })

  }

  const handlePayNow = () => {
    if (checkstatus){
      let sendPayload = {
          applicationData:  journeyState.journeyData,
          journeyData: {
            _id: journeyState.journeyId,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex - 1,
            applicationNo: journeyState.applicationNo,
            illustrationNumber: journeyState.illustrationNumber,
            proposalEntryId: journeyState.proposalEntryId,
            premium: journeyState.premium ,
            lastPageCode: props.pageId,
            paymentStep:  journeyState.paymentStep,
            planOption: journeyState.planOption,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          },
        }
        saveApplication(sendPayload).then(res => {
          console.log(res,journeyState, "application response")
          
          const paymentPayload = {
            journeyId: journeyState.journeyId,
            module: lastTransaction?.paymentMethod  || "payment"
          }
          console.log(paymentPayload, "paymentPayload")
          paymentText(paymentPayload)
            .then(res => {
              console.log(res)
              let abortTransactionPayload = {
                journeyId: journeyState.journeyId,
                applicationNumber: journeyState.applicationNo,
                status: 'Aborted',
                srcTraceId: res.data.payload.srcTraceId,
                amount: res.data.payload.amount,
                paymentTxnId: 0,
                source: 'ISNP',
                paymentTxnDate: res.data.payload.applicationLaunchDate,
              }
              console.log(abortTransactionPayload, "abortTransactionPayload")
              saveTransactionDetails(abortTransactionPayload).then((result) => {
                props.setCurrentSectionIndex(0) // this moves to first section of this page
              })
            })
            .catch(error => {
              console.log(error)
            })
        }).catch(err => {
          console.log(err, "err in saveApplication")
        })    
    }else{
      errorToastr("Please check status first by clicking on check status button.")
    }   
  }


  const handleCheckStatus = async () => {
    let temp = journeyState.journeySteps
    if (!checkstatus) {
      try {
        if (isPostRFIPayment) {
          const statusRes = await checkPaymentStatusEnquiry({
            applicationNumber: journeyState.applicationNo,
          })
          const mappedStatus = mapReceiptEnquiryToPaymentStatus(statusRes)
          const receipt = statusRes?.data?.response?.[0] || {}

          if (mappedStatus === "Success") {
            const transactionObj = buildPostRFISuccessTransaction(
              receipt,
              journeyState,
              allJourneyData
            )
            try {
              await saveTransactionDetails({
                journeyId: journeyState.journeyId,
                ...transactionObj,
              })
              promoteToSuccessfulSection(temp, transactionObj)
            } catch (err) {
              console.info("checkPaymentStatusEnquiry save failed", err)
              errorToastr("Error updating Post RFI transaction details")
            }
          } else {
            errorToastr(
              "Your Post RFI payment was cancelled or failed. Please click on Proceed to retry with correct RFI bank details."
            )
          }
        } else {
          let payload = {
            applicationNumber: [journeyState?.applicationNo],
          }
          const data = await checkPaymentStatusCPG(payload)
          let response = data?.data || []
          if (response.length > 0) {
            response = response[0]
            const paymentMethod = response?.srcPaymentMethod || ""
            if (response?.status?.toLowerCase() === "success") {
              let transactionObj = {
                amount: response?.amount || "",
                applicationNumber: journeyState?.applicationNo || "",
                errMsg: response?.mandateResponse?.verification_error_desc || "",
                journeyId: journeyState.journeyId || "",
                mandate: {
                  status: response?.mandateResponse?.status || "",
                },
                mandateId: response?.mandateId || "",
                mandateTokenId: response?.mandateTokenId || "",
                mandateTxnDate: response?.createdDate || "",
                mandateTxnId: response?.mandateTxnId || "",
                paymentMethod: paymentMethod,
                source: response?.source || "",
                srcTraceId: response?.srcTraceId,
                status: response?.status || "",
              }
              if (response?.receiptNo) {
                transactionObj.receiptNo = response.receiptNo
              }
              if (response?.receiptid) {
                transactionObj.receiptid = response.receiptid
              }
              let payloadForSaveTransaction = {
                journeyId: journeyState.journeyId,
                ...transactionObj,
              }

              try {
                if (
                  SIPaymentTypes.includes(paymentMethod) ||
                  ChequePaymentTypes.includes(paymentMethod)
                ) {
                  await saveTransactionDetails(payloadForSaveTransaction)
                } else {
                  await saveBasbaTransactionLogs(payloadForSaveTransaction)
                }
                promoteToSuccessfulSection(temp, transactionObj)
              } catch (err) {
                console.info("checkPaymentStatusFailed")
                errorToastr("Error updating Transaction Details")
              }
            } else {
              errorToastr(
                "The SI mandate creation failed from your bank account. Please click on Proceed to retry the payment."
              )
            }
          }
        }
      } catch (error) {
        const defaultMsg = isPostRFIPayment
          ? "Unable to verify Post RFI payment status. Please try again."
          : error?.response?.data?.errors ||
            error?.response?.data?.message ||
            error.message
        errorToastr(defaultMsg)
        console.error("Error checking payment status:", error)
      }
    } else {
      errorToastr("Please close session and re-try")
    }
    setCheckstatus(true)
  }

  return (
    <>
    <Loader1/>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
              `}
      </style>
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                    <h1 className="iselect-heading">
                      Unsuccessful Transaction
                    </h1>
                  </div>
                  <div className="app-quatation nri-mt-space hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>

                <div className="iselect-padding payment-design successful-page">
                  <div className="success-content">
                    {" "}
                    <img src="images/unsuccess.png" />
                    <p style={{ marginTop: "15px" }}>
                      {isPostRFIPayment
                        ? "Your Post RFI payment has not been received. Please try again."
                        : "Your Payment has not been received. Please try again."}
                    </p>
                  </div>
                  <div className="input-payment">
                    <div className="iselect-mg-bottom row">
                      <div className="col-md-4 col-xs-12 all-box-padding-right">
                        <InputContainer className="form-group">
                          <label className="input-label">Transaction Status:</label>
                          <input
                            className="form-control"
                            type="text"
                            name="tstatus"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.status || "FAIL"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                      <div className="col-md-4 col-xs-12 all-box-padding-middle">
                        <InputContainer className="form-group">
                          <label className="input-label">
                            Transaction Date & Time:
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="tdate"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.paymentTxnDate ? getDateInFormat(journeyState.paymentDecryptData?.paymentTxnDate/1000) || "NA" : "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                      <div className="col-md-4 col-xs-12 all-box-padding-left">
                        <InputContainer className="form-group">
                          <label className="input-label">Paid From:</label>
                          <input
                            className="form-control"
                            type="text"
                            name="pfrom"
                            // required={true}
                            placeholder={
                              isPostRFIPayment
                                ? "Post RFI"
                                : journeyState.paymentDecryptData?.paymentMethod || "NA"
                            }
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                    </div>
                    <div className="iselect-mg-bottom row" style={{"justifyContent": "start"}}>
                      <div className="col-md-4 col-xs-12 all-box-padding-right">
                        <InputContainer className="form-group">
                          <label className="input-label">
                            Transaction Reference Number:
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="trefno"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.paymentTxnId || "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                      <div className="col-md-4 col-xs-12 all-box-padding-middle">
                        <InputContainer className="form-group">
                          <label className="input-label">
                            Payment Amount ( <span className="fa fa-rupee"></span>):
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="pamount"
                            // required={true}
                            placeholder={journeyState.paymentDecryptData?.amount || journeyState.premium || "NA"}
                            disabled={true}
                            id={1}
                          ></input>
                        </InputContainer>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p style={{ textAlign:"center", color:"red"}}>
                      {isPostRFIPayment ? (
                        <>
                          Your Post RFI payment receipt could not be confirmed at this time.<br/>
                          Please click on Check Status to verify your Post RFI payment receipt status.
                        </>
                      ) : (
                        <>
                        Oops! Seems like your SI mandate creation failed from your bank account Bank Account/Cards.<br/>
                        Please click on check status button to confirm transaction status.
                        </>
                      )}
                    </p>

                  </div>
                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-right">
                        <a
                          style={{
                            marginRight: "5px",
                          }}
                        >
                          {" "}
                          <input
                            className="previous-btn cen text-uppercase"
                            style={{
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                            }}
                            type="submit"
                            value="Check Status"
                            onClick={handleCheckStatus}
                          />
                          <input
                            className="previous-btn cen text-uppercase"
                            style={checkstatus ? {
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                            } : {
                              pointerEvents: "none",
                              background : "gray",
                              color : "white",
                              padding: "14px 40px",
                              border: "none",
                              cursor : "not-allowed"
                            }}
                            disabled={!checkstatus}
                            type="submit"
                            value="Proceed"
                            onClick={handlePayNow}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="clearfix"></div>
                {/* <!--mobile view button--> */}
                <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                  <div className="iselect-mg-bottom">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                        <div className="previous-btn cen" style={{
                          marginRight : "5px"
                        }}>
                          <a>
                            {" "}
                            <button
                              type="submit"
                              value="button1"
                              style={{
                                backgroundColor: "transparent",
                                padding: "0px 10px",
                                border: "none",
                                color: "#fff",
                              }}
                              onClick={handleCheckStatus}
                            >
                              Check Status
                            </button>{" "}
                           
                          </a>
                        </div>
                        <div className="previous-btn cen" style={!checkstatus ? {
                          background : "gray",
                        } : {}}>
                          <a>
                            <button
                              type="submit"
                              value="button1"
                              style={
                              checkstatus ? {
                                backgroundColor: "transparent",
                                padding: "0px 10px",
                                border: "none",
                                color: "#fff",
                              } : {
                                pointerEvents: "none",
                                background : "gray",
                                color : "white",
                                border: "none",
                                padding: "0px 10px",
                                cursor : "not-allowed"
                              }
                            }
                              onClick={handlePayNow}
                            >
                              Proceed
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--mobile view button-->  */}
                <div style={{textAlign:"center",color:"red"}}>
                  {isPostRFIPayment
                    ? "If your Post RFI payment was not processed successfully, you can re-try by clicking on Proceed and submitting correct RFI bank details."
                    : "In case the lien SI mandate was not created on your account Bank Account/Cards, you can re-try by clicking on Proceed Button."}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
